import { Steps } from "antd"
import { useTranslation } from "react-i18next"

const initialSteps = [
    {
        title: 'Enter your email',
        description: 'Enter your email id',
    },
    {
        title: 'Verify your email',
        description: 'Enter verification code'
    },
    {
        title: 'Enter your details',
        description: 'Enter your details',
    },
    {
        title: 'Choose plan & complete payment',
        description: 'Choose a best plan for your organization',
    }
]
const RegistrationSteps = (props) => {
    const { currentStep } = props
    const { t } = useTranslation()

    const steps = initialSteps.map(step => ({
        ...step,
        title: t(step.title),
        description: t(step.description),
    }))

    return (
        <Steps current={currentStep} direction="vertical" items={steps} />
    )
}

export default RegistrationSteps